;
(function (ng) {
  'use strict';

  angular.module('search', []);
})(window.angular);